// extracted by mini-css-extract-plugin
export default {"Heading":"no-data-card-module__Heading--duzkw","Box":"no-data-card-module__Box--_fVea"};